import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <MediaSection />
        <RankingSection />
        <CommentsSection />
        <ContactSection />
        <CarouselSection />
        <IndexSection />
        <FaqSection />
        <AboutSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}